import { useTransition } from "react";
import { toast } from "sonner";
import { Icone } from "@/components/Icone";
import { assumirAction } from "@/web/src/acoes";

/**
 * Assumir cala o assistente NESTA conversa — as outras seguem com ele.
 * Devolver reabre para o assistente responder.
 *
 * `curto` é o rótulo do cabeçalho ("Assumir", "Devolver"); por extenso, ele
 * aparece na barra de baixo, onde há espaço para dizer o que acontece.
 */
export function BotaoAssumir({
  telefone,
  atendimentoHumano,
  curto,
}: {
  telefone: string;
  atendimentoHumano: boolean;
  curto?: boolean;
}) {
  const [pendente, iniciar] = useTransition();
  const rotulo = atendimentoHumano ? (curto ? "Devolver" : "Devolver ao assistente") : curto ? "Assumir" : "Assumir conversa";
  return (
    <button
      type="button"
      disabled={pendente}
      title={atendimentoHumano ? "Devolver a conversa ao assistente" : "Assumir: o assistente para de responder nesta conversa"}
      onClick={() =>
        iniciar(async () => {
          const r = await assumirAction(telefone, !atendimentoHumano);
          if (!r.ok) toast.error(r.erro);
          else toast.success(atendimentoHumano ? "Conversa devolvida ao assistente." : "Você assumiu esta conversa. O assistente parou de responder nela.");
        })
      }
      className={
        "flex h-9 shrink-0 items-center gap-1.5 rounded-full px-4 text-[13px] font-semibold whitespace-nowrap transition-[filter,background-color,transform] active:scale-[0.98] disabled:opacity-50 " +
        (atendimentoHumano
          ? "bg-[var(--color-cartao)] text-[var(--color-tinta)] shadow-botao hover:bg-[var(--color-painel)]"
          : "bg-[var(--color-marca)] text-[var(--color-sobre-marca)] hover:brightness-110")
      }
    >
      {atendimentoHumano && <Icone nome="agente" className="h-4 w-4" />}
      {pendente ? "…" : rotulo}
    </button>
  );
}
